import Vue from "vue";
import { SessionHelper } from "@/helpers/utilities/sessionHelper";
import { createPinia, PiniaVuePlugin, getActivePinia } from "pinia";

/**
 * Initializes Pinia store
 * @returns { object } Pinia store
 */
export default {
  init() {
    // Setup pinia
    Vue.use(PiniaVuePlugin);
    const pinia = createPinia();
    pinia.use(resetStore);
    Vue.use(pinia);

    SessionHelper.onLogout(() => this.resetStore());
    return pinia;
  },

  resetStore() {
    const pinia = getActivePinia();
    pinia._s.forEach(store => {
      if (store.$id !== "settings") {
        store.resetStore();
      }
    });
  }
};

// Plugins
/**
 * Resets a pinia store to its initial state
 * @param { object } Pinia Pinia store
 * @param { Pinia } Pinia.store current store
 */
function resetStore({ store }) {
  const initialState = JSON.parse(JSON.stringify(store.$state));
  store.resetStore = () => {
    Object.keys(initialState).forEach(key => {
      if (!initialState.preservableStates?.includes(key)) {
        store.$state[key] = JSON.parse(JSON.stringify(initialState[key]));
      }
    });
  };
}
